var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
var MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
var ACCEPTED_TYPES = ["image/jpeg", "application/pdf", "video/mp4"];
export function AttachmentSection(_a) {
    var files = _a.files, onChangeFile = _a.onChangeFile;
    var inputRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
    ];
    var handleFileChange = function (index) { return function (event) {
        var _a, _b;
        var file = (_b = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
        if (!file) {
            onChangeFile(index, null);
            return;
        }
        if (!ACCEPTED_TYPES.includes(file.type)) {
            window.alert("Tipo de arquivo inválido. Utilize apenas JPEG, PDF ou MP4.");
            event.target.value = "";
            return;
        }
        if (file.size > MAX_FILE_SIZE_BYTES) {
            window.alert("Tamanho máximo por arquivo é de 10MB.");
            event.target.value = "";
            return;
        }
        onChangeFile(index, file);
    }; };
    var triggerInput = function (index) {
        var _a;
        (_a = inputRefs[index].current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleRemoveFile = function (index) {
        onChangeFile(index, null);
        if (inputRefs[index].current) {
            inputRefs[index].current.value = "";
        }
    };
    return (_jsxs("section", __assign({ className: "space-y-4" }, { children: [_jsxs("h2", __assign({ className: "text-lg font-semibold text-[#0f4098]" }, { children: ["Anexo de arquivos", " ", _jsx("span", __assign({ className: "font-normal text-gray-500" }, { children: "(opcional)" }))] })), _jsx("p", __assign({ className: "text-sm text-gray-600" }, { children: "Imagem ou v\u00EDdeo (JPEG, PDF, MP4; tamanho m\u00E1ximo por arquivo: 10MB)" })), _jsx("div", __assign({ className: "space-y-3" }, { children: files.map(function (file, index) { return (_jsxs("div", __assign({ className: "flex items-center justify-between border-b border-gray-200 pb-2" }, { children: [_jsx("div", __assign({ className: "flex-1 min-w-0" }, { children: _jsx("p", __assign({ className: "text-sm text-gray-700 truncate" }, { children: file ? file.name : "Nenhum arquivo selecionado" })) })), _jsxs("div", __assign({ className: "flex items-center gap-2 ml-4" }, { children: [file && (_jsx("button", __assign({ type: "button", className: "text-xs text-red-600 hover:underline", onClick: function () { return handleRemoveFile(index); } }, { children: "Remover" }))), _jsx("button", __assign({ type: "button", className: "inline-flex items-center justify-center rounded-md border border-[#0f4098] px-4 py-2 text-sm font-medium text-[#0f4098] hover:bg-[#0f4098] hover:text-white transition-colors", onClick: function () { return triggerInput(index); } }, { children: "Anexar" })), _jsx("input", { ref: inputRefs[index], type: "file", className: "hidden", accept: ACCEPTED_TYPES.join(","), onChange: handleFileChange(index) })] }))] }), index)); }) }))] })));
}
